




import { Component, Mixins } from "vue-property-decorator";

@Component
export default class ViewNameIndicator extends Mixins() {
  get viewName(): string {
    return this.replaceWording(this.$route.name);
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  private replaceWording(text: string): string {
    return text.replace(/フォーマット/g, this.formatNameWording);
  }
}
